import { Route, Routes } from 'react-router-dom';

import AuthIntegrationCallback from './integration';
import AuthLoginCallback from './login';

export default function AuthCallback() {
  return (
    <Routes>
      <Route element={<AuthLoginCallback />} path="google/callback" />
      <Route element={<AuthIntegrationCallback />} path=":provider/callback" />
    </Routes>
  );
}
